import type { Methodology } from '@/types/gmb';

export default function MethodologySection({ methodology }: { methodology: Methodology }) {
  return (
    <section className="mx-auto w-full max-w-[1200px] px-4 pt-12 md:px-8 md:pt-14">
      <div className="mb-5 flex items-center gap-2">
        <span className="flex h-8 w-8 items-center justify-center rounded-md bg-teal-50 text-teal-700">
          <i className="ri-book-open-line" />
        </span>
        <h2 className="text-lg font-bold text-slate-900 md:text-[1.5rem]">方法與限制</h2>
      </div>

      <div className="grid grid-cols-1 gap-4 lg:grid-cols-3">
        <div className="rounded-lg border border-slate-200 bg-white p-5">
          <p className="text-xs font-semibold uppercase tracking-wider text-slate-400">評分方法</p>
          <p className="mt-2 text-sm leading-relaxed text-slate-700">
            依 11 項公開資料指標，各自配分後加總為 0–100 健康度，並依門檻轉換為 A–E 等級。
          </p>
          <div className="mt-4 flex flex-wrap gap-x-5 gap-y-1 text-xs text-slate-500">
            <span>版本：{methodology.version || '—'}</span>
            <span>更新：{methodology.updatedAt || '—'}</span>
          </div>
        </div>

        <div className="rounded-lg border border-slate-200 bg-white p-5">
          <p className="text-xs font-semibold uppercase tracking-wider text-slate-400">資料來源</p>
          <ul className="mt-2 space-y-2 text-sm text-slate-700">
            {(methodology.dataSources && methodology.dataSources.length > 0 ? methodology.dataSources : ['—']).map(
              (source, index) => (
                <li key={index} className="flex items-start gap-2">
                  <i className="ri-database-2-line mt-0.5 text-slate-400" />
                  {source}
                </li>
              ),
            )}
          </ul>
        </div>

        <div className="rounded-lg border border-slate-200 bg-white p-5">
          <p className="text-xs font-semibold uppercase tracking-wider text-slate-400">已知限制</p>
          <ul className="mt-2 space-y-2 text-sm text-slate-700">
            {(methodology.notes && methodology.notes.length > 0 ? methodology.notes : ['—']).map((note, index) => (
              <li key={index} className="flex items-start gap-2">
                <i className="ri-error-warning-line mt-0.5 text-slate-400" />
                {note}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}